import { Component, forwardRef, OnInit, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';

@Component({
    selector: 'app-input-color-react',
    templateUrl: './input-color-react.component.html',
    styleUrls: ['./input-color-react.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputColorReactComponent),
            multi: true
        }
    ]
})

export class InputColorReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.value) {
            this.control.setValue(this.value);
            this.valorChange.emit(this.value);
        }
        this.setAndUpdateValidators();
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.setAndUpdateValidators();
    }
}
